import { USER_LEAD_ASSIGNMENT_ACTION_TYPE } from '../actions';

const initialState = {};

const userLeadAssignmentReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case USER_LEAD_ASSIGNMENT_ACTION_TYPE.GET_LEAD_ASSIGMENT_RULE:
    case USER_LEAD_ASSIGNMENT_ACTION_TYPE.ADD_LEAD_ASSIGMENT_RULE:
    case USER_LEAD_ASSIGNMENT_ACTION_TYPE.EDIT_LEAD_ASSIGMENT_RULE:
      return payload || initialState;

    case USER_LEAD_ASSIGNMENT_ACTION_TYPE.DELETE_LEAD_ASSIGMENT_RULE:
      return initialState;

    default:
      return state;
  }
};

export default userLeadAssignmentReducer;
